import React, { useState } from "react";
import "./SmartAppBanner.scss";
import { isMobile } from "react-device-detect";

import useFetchJSONData from "@hooks/useFetchJSONData";

export default function SmartAppBanner() {
  const [isVisible, setIsVisible] = useState(true);
  const { data, loading, error } = useFetchJSONData("smart-app-banner");

  const lang = window.THREE_REACT_APP_GLOBAL.language;
  const labelOpen = lang === "en" ? "Open" : "開啟";

  function handleDismiss() {
    setIsVisible(false);
  }

  if (!isMobile) return null;

  if (loading || error || !data) return null;

  const { isOn, content, url, icon } = data;

  if (
    !isOn ||
    !isVisible ||
    content === "" ||
    content === null ||
    url === "" ||
    url === null ||
    icon === "" ||
    icon === null
  )
    return null;

  return (
    <React.Fragment>
      <div className="container-smart-app-banner-space" />
      <div className="container-smart-app-banner">


        <button className="btn-dismiss" onClick={handleDismiss}>
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            xmlns="http://www.w3.org/2000/svg"
          >
            <polygon points="0,0 0,30 30,0" fill="#DFD6FF" />

            <path
              d="M12 5L5 12"
              stroke="#fff"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M5 5L12 12"
              stroke="#fff"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </button>

        <div className="container-sub-content">
          <img className="app-icon-img" src={icon} alt="APP Icon" />
          <div className="sub-container">
            <span className="content">{content}</span>
            <a className="btn-open-app" href={url}>
              {labelOpen}
            </a>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
